/*SYSTEM IMPORTS*/
import React from 'react'
import ReactPlayer from 'react-player'

import './style'
import './media'

/*Ui*/
import Cont from 'components/ui/Cont'
import ListVideos from 'components/ui/ListVideos'
import VideoItem from 'components/ui/VideoItem'
import ActionWrapp from 'components/ui/ActionWrapp'
import Btn from 'components/ui/Btn'

/*CORES*/
import AppCore from 'cores/AppCore'

const ContVideo = ( props = {} ) => {
    const {
        id,
        value: {
            videos = [],
        } = {}
    } = props

    const [limit, setLimit] = React.useState( 3 )

    const handleShowMore = () => {
        setLimit(limit+3)
    }

    const main_title = AppCore.Interfaces.t( "DoctorLanding.Ui.ContVideos.Index.Title" )

    return(
        <>
            {videos.length > 0 &&
            <Cont id={`block-${id}`} className="cont-videos">
                <h2>
                    { main_title }
                </h2>
                <ListVideos>
                    {videos.limit(limit).map( item => (
                        <VideoItem
                            key={item.id}
                            title={item.value}
                        >
                            <ReactPlayer
                                className="video"
                                url={item.videoLink}
                                controls
                                width='100%'
                                height='100%'
                            />
                        </VideoItem>
                    ))}
                </ListVideos>
                <ActionWrapp center>
                    { limit < videos.length && <Btn
                        border
                        onClick={handleShowMore}
                    >
                        { AppCore.Interfaces.t( "DoctorLanding.Ui.ContVideos.Index.ButtonShowAll" ) }
                    </Btn>}
                </ActionWrapp>
            </Cont>
            }
        </>
    )
}

export default ContVideo